import { ImgHTMLAttributes } from "react";

export interface AppLogoIconProps
  extends Omit<ImgHTMLAttributes<HTMLImageElement>, "src" | "alt"> {}

const AppLogoIcon = (props: AppLogoIconProps) => {
  return <img alt="Ximly logo" src={"https://public-assets.ximly.app/logo-icon.svg"} {...props} />;
};

export default AppLogoIcon;
